import consts from "consts";
import qs from "qs";
import urlmod from "pnurl";
import errortrack from "errortrack";
import Overlay from "overlay";
import popbox from "popbox";
import ua from "ua";
import $ from "zepto";
import ClipboardJS from "clipboard";
import { shared as progress } from "progress";

let loaded = {};
let $body = $("body");
function load(src, cb) {
  return new Promise((resolve, reject) => {
    if (loaded[src]) {
      return resolve();
    }

    var script = $("<script />");
    script.on("load", function() {
      loaded[src] = true;
      resolve();
    });
    script.on("error", function(error) {
      reject(error);
    });
    script.attr("src", src);
    script.appendTo($body);
  });
}

module.exports = {
  share: function(shareConfig) {
    wx.onMenuShareTimeline(shareConfig);
    wx.onMenuShareAppMessage(shareConfig);
    wx.onMenuShareQQ(shareConfig);
  },
  load: function(debug, appId) {
    return load("//res.wx.qq.com/open/js/jweixin-1.3.2.js")
      .then(function() {
        wx.error(function(res) {
          errortrack.track(res);
        });
        let configUrl = `//${consts.apiHost}/wechat/wxconfig.js?debug=${
          debug ? "true" : "false"
        }&apis=["onMenuShareTimeline","onMenuShareQQ","onMenuShareAppMessage","chooseWXPay"]`;
        if (appId) {
          configUrl = qs.append(configUrl, {
            appId
          });
        }
        return load(configUrl);
      })
      .catch(function() {
        console.log("wxapi加载失败");
      });
  },
  showShareHint: function(popText, popLink, popTip) {
    if (ua.isWechat() || ua.isMiniProgram()) {
      let overlay = new Overlay();
      let hint = $(`<img src="${require("ui/img/share-hint.png")}" />`);
      hint.css({
        position: "fixed",
        top: 10,
        right: ua.isMiniProgram() ? 80 : 30,
        width: 255,
        zIndex: 130
      });
      hint.appendTo($("body"));
      overlay.show();
      hint.on("click", () => {
        overlay.remove();
        hint.remove();
      });
      overlay.on("tap", () => {
        overlay.remove();
        hint.remove();
      });
    } else {
      let text;
      if (popText) {
        text = popText;
      } else {
        text = `${popTip ||
          "复制以下链接到微信～"}<br /><span class="link">${popLink ||
          location.href}</span>`;
      }
      popbox.show(text, [
        {
          text: "复制链接",
          fn() {}
        },
        {
          text: "知道了"
        }
      ]);

      let $btn = popbox.elem.find("button")[0];
      $($btn).attr("data-clipboard-text", popLink);
      var clipboard = new ClipboardJS($btn);
      clipboard.on("success", function(e) {
        progress.showMessage("已复制到剪贴板");
        popbox.hide();
      });
    }
  },
  login: function(config) {
    config = config || {};
    var scope = config.isUserinfoLogin ? "snsapi_userinfo" : "snsapi_base";
    let url = "https://open.weixin.qq.com/connect/oauth2/authorize";
    let info = {
      appid: config.weixinAppId || consts.wechatAppId,
      redirect_uri: config.redir ? urlmod.resolve(config.redir) : location.href,
      response_type: "code",
      scope: scope,
      state: ua.isBeta() ? "m-beta" : "m-piaoniu"
    };
    console.log(url + "?" + qs.stringify(info) + "#wechat_redirect");
    location.href = url + "?" + qs.stringify(info) + "#wechat_redirect";
  },
  setTitle: function(title) {
    $(".navbar .title").text(title);
    document.title = title; // hack在微信等webview中无法修改document.title的情况
    if (ua.isWechat()) {
      let $iframe = $('<iframe src="/favicon.ico" />').hide();
      $iframe.on("load", function() {
        setTimeout(function() {
          $iframe.off("load").remove();
        }, 0);
      });
      $iframe.appendTo($body);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mods/wxapi.js